<div class="modelContainer alignCenter" *ngIf="reportData!=null">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle">
    Event History - {{data.workflowName}}
  </div>
  <div class="modelBody">
    <div class="row">
      <div class="col-2">
        <div class="eventId-col eventId-col-bg">Run ID</div>
        <div class="runIdList">
          <div *ngFor="let event of reportData">
            <div class="eventId-col pointer" [ngClass]="{'isActive': isActiveEvent(event.eventId)}" (click)="loadEventData(event)">{{event.eventId}}</div>
          </div>
        </div>
      </div>
      <div class="col-10">
        <div class="row">
          <div class="col-6 alignLeft"><span class="ml-3 font-bold">Time Elapsed: </span><span>{{selectedEvent.timeElapsed}}</span></div>
          <div class="col-6 alignRight" *ngIf="selectedEvent.requestId !== 0"><span class="font-bold">Request Id: </span><span>{{selectedEvent.requestId }}</span></div>
        </div>
        <div class="row mb-4">
          <div class="col-6 alignLeft"><span class="ml-3 font-bold">Triggered At: </span><span>{{selectedEvent.triggeredAt | date: 'yyyy-MM-dd HH:mm:ss'}}</span></div>
        </div>

        <div class="report-details">
          <div class="customCompoReport" *ngFor="let item of selectedEvent.componentDetails">
            <div class="minor-background border-radius-div" *ngIf="item.name.includes('Monitoring')">
              <div class="padding-box">
                <div class="row mb-2">
                  <div class="col-6 colored-text heading1 alignLeft">Monitoring</div>
                  <div class="col-6 alignRight">{{item.triggerTime | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Violation id: {{item.violationId}}</div>
                  <div class="col-6">Data Source: {{item.datasource}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Parameter Name: {{item.parameterName}}</div>
                  <div class="col-6">Violation Type: {{item.violationType}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Status: {{item.status}}</div>
                </div>

              </div>
            </div>
            <div class="minor-background border-radius-div" *ngIf="item.name.includes('Gap_Analysis')">
              <div class="padding-box">
                <div class="row mb-2">
                  <div class="col-6 colored-text heading1 alignLeft">Gap Analysis</div>
                  <div class="col-6 alignRight">{{item.triggerTime | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Gap Config Name: {{item.gapConfigName}}</div>
                  <div class="col-6">Gap: {{item.gap}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Source 1: {{item.source1}}</div>
                  <div class="col-6">Source 2: {{item.source2}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Status: {{item.status}}</div>
                </div>
              </div>
            </div>
            <div class="minor-background border-radius-div" 
            *ngIf="item.name.includes('Flowsheet') || item.name.includes('custom') || item.name.includes('Formula_Builder') || item.type.includes('custom')">
              <div class="padding-box">
                <div class="row mb-2">
                  <div class="col-6 colored-text heading1 alignLeft">{{item.name}}</div>
                  <div class="col-6 alignRight">{{item.triggerTime  | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
                </div>
                <div *ngFor="let itm of item.modelDetails">
                  <div class="row col-12 alignLeft"><span class="ml-3 font-bold">Model Name:&nbsp;</span><span>{{itm.modelName}}</span></div>
                  <div class="row col-12 alignLeft"><span class="ml-3 font-bold">Version:&nbsp;</span>{{itm.version}}</div>
                  <br />
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Status: {{item.status}}</div>
                </div>
              </div>
            </div>
            <div class="minor-background border-radius-div" *ngIf="item.name.includes('Send_Data')">
              <div class="padding-box">
                <div class="row mb-2">
                  <div class="col-6 colored-text heading1 alignLeft">Send Data</div>
                  <div class="col-6 alignRight">{{item.triggerTime  | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
                </div>
                <div class="row alignLeft">
                  <div class="col-6">Status: {{item.status}}</div>
                  <div class="col-6">Selected Datasource: {{item.datasource}}</div>
                </div>
              </div>
            </div>
            <div class="mt-1 down-arrow"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
